function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  "data-svg-class": "icon-stroke",
  cx: 16.6243,
  cy: 28.2537,
  rx: 3.90698,
  ry: 3.90698,
  stroke: "#BBC0CF",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  "data-svg-class": "icon-stroke",
  cx: 28.345,
  cy: 28.2537,
  r: 3.90698,
  stroke: "#BBC0CF",
  strokeWidth: 2
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  "data-svg-class": "icon-stroke",
  cx: 40.0662,
  cy: 28.2537,
  r: 3.90698,
  stroke: "#BBC0CF",
  strokeWidth: 2
});

function SvgIssueOther(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssueOther);
export default __webpack_public_path__ + "static/media/IssueOther.7ba7a99c.svg";
export { ForwardRef as ReactComponent };